export default __webpack_public_path__ + "static/media/sd-gosamraksha-color@2x.e62a9660.png";